// ─────────────────────────────────────────────────────────────────────────
// Seguimiento.js — tercera columna de Mi tablero: pestañas "Esperando",
// "Congelados" y "Cerrados" (últimos 30 días), cada una con su contador.
// Usa el patrón de pestañas del ERP (.bini-tabs/.bini-tab; en móvil .set-tabs).
// ─────────────────────────────────────────────────────────────────────────
import React from "react";
import { C, boton, diaDe, fmtDia, FilaFrente } from "./componentes";

export const PESTANAS = ["esperando", "congelados", "cerrados"];

const Seguimiento = ({ hoy, esperando, congelados, cerrados, pestana, onPestana, patch }) => {
  const tabs = [
    ["esperando", "Esperando", esperando.length],
    ["congelados", "Congelados", congelados.length],
    ["cerrados", "Cerrados", cerrados.length],
  ];
  const vacio = texto => <div style={{ color: C.suave }}>{texto}</div>;
  return (
    <div>
      <div className="bini-tabs set-tabs" role="tablist" style={{ marginBottom: 12 }}>
        {tabs.map(([k, rotulo, n]) => (
          <button
            key={k}
            role="tab"
            aria-selected={pestana === k}
            className={`bini-tab${pestana === k ? " active" : ""}`}
            style={{ fontSize: 14, whiteSpace: "nowrap" }}
            onClick={() => onPestana(k)}
          >
            {rotulo} ({n})
          </button>
        ))}
      </div>

      {pestana === "esperando" && (
        <>
          {esperando.length === 0 && vacio("No hay frentes esperando a terceros.")}
          {esperando.map(f => <FilaFrente key={f._id} f={f} hoy={hoy} />)}
        </>
      )}

      {pestana === "congelados" && (
        <>
          {congelados.length === 0 && vacio("No hay frentes congelados.")}
          {congelados.map(f => (
            <FilaFrente key={f._id} f={f} hoy={hoy}>
              <div style={{ marginTop: 8 }}>
                <button style={boton()} onClick={() => patch(f._id, { estado: "activo" })}>Reactivar</button>
              </div>
            </FilaFrente>
          ))}
        </>
      )}

      {pestana === "cerrados" && (
        <>
          {cerrados.length === 0 && vacio("No se cerró nada en los últimos 30 días.")}
          {cerrados.map(f => (
            <FilaFrente
              key={f._id}
              f={f}
              hoy={hoy}
              extra={
                <div style={{ fontSize: 13, color: C.suave, marginTop: 6 }}>
                  {f.estado === "descartado" ? "Descartado" : "Cerrado"} el {fmtDia(diaDe(f.cerradoAt))}{f.cerradoMotivo ? ` — ${f.cerradoMotivo}` : ""}
                </div>
              }
            />
          ))}
        </>
      )}
    </div>
  );
};

export default Seguimiento;
